export const Sites = [
    {
      id: 0,
      slug: "rishikesh-riverfront-camping",
      title: "Riverfront Escape",
      location: "Rishikesh, Uttarakhand",
      description: "Sleep under the stars with the soothing sound of the Ganga flowing beside you. Yoga and meditation included.",
      image: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹2,499",
      rating: 4.8,
      duration: "3 days",
      guests: 20,
      gallery: [
        "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1519340333755-abea3e9c2521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      ],
      itinerary: [
        { day: 1, title: "Arrival & Welcome", description: "Welcome to Riverfront Escape! Check-in at 2 PM, settle into your accommodation, and enjoy a welcome tea with local snacks. Evening orientation and yoga session by the riverbank." },
        { day: 2, title: "River Adventures", description: "Morning meditation session, followed by breakfast. Afternoon river activities including kayaking and swimming. Evening bonfire with traditional music and dinner under the stars." },
        { day: 3, title: "Departure", description: "Final sunrise yoga session, breakfast, and departure by 11 AM. Take home memories and a gift hamper with local products." },
      ],
      amenities: ["Tents", "Bonfire", "Yoga Sessions", "Hot Meals", "Emergency Medical Support", "Blankets & Pillows", "Flashlights"],
      reviews: [
        { name: "Rajesh Kumar", rating: 5, comment: "Amazing experience! The yoga sessions were transformative." },
        { name: "Priya Singh", rating: 5, comment: "Best camping experience. Nature at its finest with great hospitality." },
        { name: "Amit Patel", rating: 4, comment: "Good experience overall. Would recommend for beginners." },
      ]
    },
    {
      id: 1,
      slug: "manali-mountain-river-camping",
      title: "Mountain River Camping",
      location: "Manali, Himachal Pradesh",
      description: "Experience Himalayan river camping with trekking, bonfire nights, and serene nature views.",
      image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹3,299",
      rating: 4.9,
      duration: "4 days",
      guests: 25,
      gallery: [
        "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1519904981063-b0cf448d479e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1446521653236-cd1b432805dc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      ],
      itinerary: [
        { day: 1, title: "Mountain Welcome", description: "Arrive at Manali. Transfer to camp by 3 PM. Welcome with hot drinks, tent setup, and evening orientation. Dinner with local delicacies." },
        { day: 2, title: "Trekking Adventure", description: "Early morning breakfast. Full day guided trek to nearby viewpoints. Packed lunch during trek. Return by evening, rest, and bonfire night with campfire stories." },
        { day: 3, title: "River Exploration", description: "Morning yoga and meditation. Adventure activities on the river - rafting or river crossing. Afternoon leisure time. Cultural evening with traditional Himachali music." },
        { day: 4, title: "Departure", description: "Final sunrise trek, breakfast, and checkout. Takeaway snacks and photos. Depart by 11 AM." },
      ],
      amenities: ["Mountain Tents", "Bonfire", "Guided Treks", "River Activities", "Professional Guides", "First Aid Kit", "Warm Clothing"],
      reviews: [
        { name: "Vikram Singh", rating: 5, comment: "Incredible mountain experience. Professional guides made it safer." },
        { name: "Neha Sharma", rating: 5, comment: "Loved the trek and river activities. Worth every rupee!" },
        { name: "Arjun Reddy", rating: 4, comment: "Good adventure, but food could be better." },
      ]
    },
    {
      id: 2,
      slug: "spiti-riverside-retreat",
      title: "Secluded Riverside Retreat",
      location: "Spiti Valley, Himachal Pradesh",
      description: "A remote camping experience along the icy rivers of Spiti. Perfect for digital detox and solitude.",
      image: "https://images.unsplash.com/photo-1519340333755-abea3e9c2521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹4,999",
      rating: 5.0,
      duration: "5 days",
      guests: 15,
      gallery: [
        "https://images.unsplash.com/photo-1519340333755-abea3e9c2521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      ],
      itinerary: [
        { day: 1, title: "Arrival in Spiti", description: "Arrive at the remote Spiti Valley. Scenic drive with stops at viewpoints. Camp setup by 4 PM. Acclimatization walk and dinner." },
        { day: 2, title: "Digital Detox Begins", description: "Mindfulness session. Nature exploration. River side meditation. Traditional meal preparation with local community members." },
        { day: 3, title: "High Altitude Trek", description: "Guided trek to high altitude viewpoints. Stunning mountain vistas. Packed picnic lunch. Photography sessions. Evening rest and wellness session." },
        { day: 4, title: "Cultural Immersion", description: "Visit local monasteries. Interact with monks. Learn about Spiti culture. Stargazing evening with astronomy insights." },
        { day: 5, title: "Farewell", description: "Final meditation, breakfast, and departure. Receive a Spiti crafts souvenir." },
      ],
      amenities: ["Premium Mountain Tents", "Icy River Access", "No WiFi (Digital Detox)", "Meditation Programs", "Expert Guides", "Organic Meals", "Telescope for Stargazing"],
      reviews: [
        { name: "Deepak Sharma", rating: 5, comment: "Perfect digital detox. The remote location was exactly what I needed." },
        { name: "Anjali Verma", rating: 5, comment: "Spiti is magical. This camp captures its essence beautifully." },
        { name: "Rohit Nair", rating: 5, comment: "One of the best experiences of my life. Highly recommended." },
      ]
    },
    {
      id: 3,
      slug: "ladakh-alpine-lake-camping",
      title: "Alpine Lake Camping",
      location: "Ladakh",
      description: "Crystal clear alpine lakes surrounded by snow-capped peaks. Perfect for adventure enthusiasts and photographers.",
      image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹3,899",
      rating: 4.9,
      duration: "5 days",
      guests: 18,
      gallery: [
        "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1446521653236-cd1b432805dc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
        "https://images.unsplash.com/photo-1519340333755-abea3e9c2521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      ],
      itinerary: [
        { day: 1, title: "Leh Arrival", description: "Arrive at Leh. Transfer to alpine camp. Acclimatization and orientation. Evening exploration of nearby villages." },
        { day: 2, title: "Lake Trek", description: "Full day trek to pristine alpine lake. Photography opportunities. Packed lunch by the lake. Evening relaxation." },
        { day: 3, title: "Adventure Day", description: "Rock climbing or mountain biking. Adventure activities suited to your preference. Evening bonfire and storytelling." },
        { day: 4, title: "Exploration", description: "Visit monasteries. Interact with local communities. Photography sunset sessions. Cultural evening." },
        { day: 5, title: "Departure", description: "Final morning trek, breakfast, and checkout. Depart by 10 AM." },
      ],
      amenities: ["Alpine Tents", "Lake Access", "Adventure Equipment", "Professional Guides", "Photography Support", "Organic Meals", "High Altitude Support"],
      reviews: [
        { name: "Rohan Khanna", rating: 5, comment: "Ladakh experience was phenomenal. The lakes are breathtaking!" },
        { name: "Sarah Malik", rating: 5, comment: "Best adventure camping ever. Perfect blend of comfort and adventure." },
        { name: "Akshay Verma", rating: 5, comment: "Stunning location. Highly professional team." },
      ]
    },
  ];